"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticValueField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const NumberInput_1 = require("./NumberInput");
const StaticValueField = (props) => {
    const { computedValue, isFloat } = props;
    return (0, jsx_runtime_1.jsx)(NumberInput_1.NumberInput, { value: computedValue, disabled: true, isFloat: isFloat });
};
exports.StaticValueField = StaticValueField;
